import { useEffect, useRef } from 'react';

interface CanvasProps {
  draw: (ctx: CanvasRenderingContext2D) => void;
  width: number;
  height: number;
  className?: string;
}

const CanvasElement = ({ draw, width, height, className }: CanvasProps) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      // Get the canvas element and its drawing context
      const canvas: HTMLCanvasElement = canvasRef.current;

      const ctx = canvas.getContext('2d');

      if (!ctx) return;
      let animationFrameId: number;

      const render = () => {
        draw(ctx);
        animationFrameId = requestAnimationFrame(render);
      };
      render();

      return () => cancelAnimationFrame(animationFrameId);
    }
  }, [draw]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      style={{ imageRendering: 'pixelated' }}
      className={className ?? ''}
    />
  );
};

export default CanvasElement;
